import React from 'react';
import './title.scss';

const Title = ({ myTitle = null, subtitle = null, level = 2 }) => {
  const HeadingTag = `h${level}`;
  
  return (
    <div className="title-container">
      <HeadingTag className="title">{myTitle}</HeadingTag>
      {subtitle && <p className="title-subtitle">{subtitle}</p>}
    </div>
  );
}

export default Title;
